import type { HTMLAttributes } from 'react'

import clsx from 'clsx'
import { SupportButton } from 'components/atoms/SupportButton/SupportButton.js'
import { CONSTS } from 'config/objectConst.js'
import { useDocumentTitle } from 'shared/hooks'

import LeftSideMenu from '../../molecules/leftSideMenu/index.js'
import { Header } from '../../organisms/Header/index'
import css from './HomeTemplate.module.scss'

// Simple variant

export function LoggedLayout({
	className,
	...props
}: HTMLAttributes<HTMLElement>) {
	useDocumentTitle(CONSTS.PROJECT_NAME)
	return (
		<div className={clsx(css.root, 'wrapper')}>
			<Header className={css.header} />

			<LeftSideMenu className={css.side} />
			<main className={clsx(css.main, 'app-scroll', className)} {...props} />

			<SupportButton />
		</div>
	)
}
